module.exports = __webpack_public_path__ + "static/media/38.f13102ef.png";